<template>
  <v-dialog v-model="dialog" width="480px" persistent>
    <v-card>
      <v-card-title
        ><div class="title--text">Đăng nhập</div>
        <v-spacer />
        <v-icon @click="cancel()" class="mr-n1">mdi-close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4 pb-2">
        <v-form ref="form" v-model="isValid">
          <div class="text-subtitle-1">
            Số điện thoại
            <span style="color: red">*</span>
          </div>
          <v-text-field
            placeholder="Nhập số điện thoại hoặc mã định danh tại đây"
            v-model="credentials.identifier"
            name="login"
            type="tel"
            color="primary"
            v-mask="'############'"
            :rules="identifierRules"
            @keyup.enter="submit()"
            outlined
            validate-on-blur
          />
          <div class="text-subtitle-1">Mật khẩu <span style="color: red">*</span></div>
          <v-text-field
            placeholder="Nhập mật khẩu tại đây"
            v-model="credentials.password"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRules"
            @click:append="showPassword = !showPassword"
            @keyup.enter="submit()"
            @keyup="$refs.form.validate()"
            color="primary"
            outlined
            validate-on-blur
          />
        </v-form>
        <v-btn
          depressed
          x-large
          color="primary"
          class="white--text text-subtitle-1 text-none mt-6"
          style="width: 100%"
          :disabled="!isValid"
          :loading="loading"
          @click="submit()"
          >Đăng nhập
        </v-btn>
        <div class="d-flex justify-center mt-6">
          <v-btn
            plain
            class="
              info--text
              text-subtitle-1 text-decoration-underline text-none
            "
            style="width: 100%"
            @click="resetPassword()"
            >Quên mật khẩu?
          </v-btn>
        </div>
        <v-btn
          plain
          color="primary"
          class="text-subtitle-1 font-weight-bold text-none mt-3"
          style="width: 100%"
          @click="register()"
          >Chưa có tài khoản? Đăng ký
        </v-btn>
      </v-card-text>
    </v-card>
    <v-dialog v-model="gradeSelectionDialog" max-width="554px">
      <v-card>
        <v-card-title>
          <div class="title--text">Chọn khối đăng ký</div>
          <v-spacer />
          <v-icon @click="gradeSelectionDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions
          class="pa-4 d-flex"
          :class="{
            'justify-space-around': $vuetify.breakpoint.mdAndUp,
            'flex-column': $vuetify.breakpoint.smAndDown
          }"
        >
          <v-card
            class="d-flex flex-column align-center elevation-0 rounded-lg border-btn"
            :class="{
              'mb-4 btn-overlay': $vuetify.breakpoint.smAndDown,
              'desktop-btn mr-4': $vuetify.breakpoint.mdAndUp
            }"
            @click="selectGrade('primary')"
          >
            <v-img src="@/assets/icon_info_g1.svg" class="mb-4 mt-6" width="141" height="114" />
            <div style="width: 85%;">
              <v-divider class="primary" />
            </div>
            <div class="primary--text font-weight-medium my-6" style="line-height: 24px">
              Đăng ký cho <span style="font-size: 20px;">Khối 1</span>
            </div>
          </v-card>
          <v-card
            class="d-flex flex-column align-center elevation-0 rounded-lg border-btn"
            :class="{
              'btn-overlay': $vuetify.breakpoint.smAndDown,
              'desktop-btn': $vuetify.breakpoint.mdAndUp
            }"
            @click="selectGrade('high')"
          >
            <v-img src="@/assets/icon_info_g10.svg" class="mb-4 mt-6" width="141" height="114" />
            <div style="width: 85%;">
              <v-divider class="primary" />
            </div>
            <div class="primary--text font-weight-medium my-6" style="line-height: 24px">
              Đăng ký cho <span style="font-size: 20px;">Khối 10</span>
            </div>
          </v-card>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
export default {
  watch: {
    signInDialog(signInDialog) {
      this.dialog = signInDialog
    }
  },
  computed: {
    ...mapGetters('layout', ['signInDialog']),
    ...mapGetters('site', ['siteLevel']),
    ...mapGetters('auth', ['isAuthenticated', 'user', 'isRequestingReset', 'isConfirmedResetOTP', 'isConfirmedOTP'])
  },
  data() {
    return {
      isValid: true,
      dialog: false,
      credentials: {
        identifier: '',
        password: ''
      },
      loading: false,
      showPassword: false,
      password: 'Password',
      identifierRules: [
        this.$rules.required,
        value => /^\d{10}$|^\d{12}$/.test(value || '') || 'Vui lòng nhập số điện thoại 10 số hoặc mã định danh 12 số'
      ],
      phoneRules: [this.$rules.required, this.$rules.phone],
      passwordRules: [this.$rules.required, this.$rules.minLength(4)],
      gradeSelectionDialog: false
    }
  },
  methods: {
    ...mapActions('auth', ['signIn']),
    ...mapActions('layout', [
      'setSignInDialog',
      'setSignUpDialog',
      'setForgotPasswordDialog',
      'setConfirmSignupDialog',
      'setConfirmForgotPasswordDialog',
      'setNewPasswordDialog',
      'setDocumentDialog',
      'setCountdownDialog'
    ]),
    ...mapMutations('layout', ['setGrade']),
    cancel() {
      this.$refs.form.reset()
      this.setSignInDialog(false)
    },
    delay(time) {
      return new Promise(rel => {
        setTimeout(() => {
          rel()
        }, time)
      })
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        await this.delay(1500)
        try {
          await this.signIn(this.credentials)
        } catch (error) {
          console.log('error: ', error)
        } finally {
          this.loading = false
        }
        if (this.user && this.isAuthenticated && !this.isConfirmedOTP) {
          this.$refs.form.reset()
          this.setSignInDialog(false)
          this.setConfirmSignupDialog(true)
        } else if (this.user && this.isAuthenticated) {
          this.$refs.form.reset()
          this.setSignInDialog(false)
        }
        this.loading = false
      }
    },
    resetPassword() {
      this.setSignInDialog(false)
      if (this.isRequestingReset) this.setConfirmForgotPasswordDialog(true)
      else if (this.isConfirmedResetOTP) this.setNewPasswordDialog(true)
      else this.setForgotPasswordDialog(true)
    },
    register() {
      this.setSignInDialog(false)
      // Site đã xác định khối: đăng ký thẳng cho khối của site, không cho chọn khối
      if (this.siteLevel) return this.selectGrade(this.siteLevel)
      this.gradeSelectionDialog = true
    },
    selectGrade(grade) {
      this.gradeSelectionDialog = false
      this.setGrade(grade)
      this.setSignUpDialog(true)
    }
  }
}
</script>
<style scoped>
.border-btn {
  border: 1.22px solid #224189;
}
.desktop-btn {
  width: 50%;
  position: relative;
}
.btn-overlay {
  width: 100%;
  position: relative;
}
.btn-overlay:hover {
  background-color: #ecf1fd !important;
}
</style>
